import React from "react";
import { useI18N } from "@src/language/language-context";
import styles from "./initial-structure-is-not-ready-yet-message-wrapper.module.scss";

const cssClassName = "initial-structure-is-not-ready-yet-message-wrapper";

export const InitialStructureIsNotReadyYetMessageWrapper = () => {
  const i18n = useI18N();

  const texts = {
    info: i18n("pages.nodeManager.initialStructureEmpty"),
  };

  return (
    <div className={styles[cssClassName]}>
      <div>{texts.info}</div>
    </div>
  );
};
